import { Box, Text } from '@chakra-ui/react';

export const AvatarPreview = () => {
  return (
    <Box>
      <Text>AvatarPreview - Coming soon</Text>
    </Box>
  );
};
